import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsToshibaComponent } from './simple-icons-toshiba.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsToshibaComponent ],
    exports:      [ SimpleIconsToshibaComponent ],
    bootstrap:    []
})
export class SimpleIconsToshibaModule {}
